import { render, staticRenderFns } from "./FinCompra.vue?vue&type=template&id=51e5b020&scoped=true"
import script from "./FinCompra.vue?vue&type=script&lang=js"
export * from "./FinCompra.vue?vue&type=script&lang=js"
import style0 from "./FinCompra.vue?vue&type=style&index=0&id=51e5b020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5b020",
  null
  
)

export default component.exports